import React from "react";
import { connect } from "react-redux";

import { NotificationProvider } from "../../UI/Notifications";
import EventCalendarSettings from "./EventCalendarSettings";

const EventCalendarSettingsWrapper = ({ event }) => {
    return (
        <NotificationProvider>
            <EventCalendarSettings event={event} />
        </NotificationProvider>
    );
};

const mapStateToProps = (store) => {
    return {
        event: store.currentEvent,
    };
};

export default connect(mapStateToProps)(EventCalendarSettingsWrapper);
